<div class="app__layout">
  <carehub-sidebar></carehub-sidebar>
  <div class="app__main">
    <carehub-header></carehub-header>
    <div class="app__content">
      <p-toast />
      <router-outlet />
    </div>
  </div>
</div>

<carehub-loader></carehub-loader>
